module.exports = __webpack_public_path__ + "static/img/taiHeImg3.28406e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taiHeImg3.png
// module id = 0yIP
// module chunks = 2